// Used to combine company data from the filter selection configuration query and the division search queries into a single mapping of id to resource.
// This is necessary because the selections that haven't been persisted yet have to be referenced in the UI with those that have been persisted.
function collectDomainCompanies({ queryClient }) {
  const companies = {};

  queryClient
    .getQueriesData(['projectsAnalyticsFilterSelectionConfiguration'])
    .forEach(([_key, query]) => {
      query.included.forEach((includedResource) => {
        if (includedResource.type === 'company') {
          companies[includedResource.id] = includedResource;
        }
      });
    });

  queryClient.getQueriesData(['divisionSearches']).forEach(([_key, query]) => {
    if (!query?.pages) return;

    query.pages.forEach((page) => {
      page.data.forEach((company) => {
        companies[company.id] = company;
      });
    });
  });

  return companies;
}

function sortCompaniesByPrimaryAndName({ companies }) {
  return companies.toSorted((firstCompany, secondCompany) => {
    if (firstCompany.attributes.primary) return -1;
    if (secondCompany.attributes.primary) return 1;

    return firstCompany.attributes.name.localeCompare(
      secondCompany.attributes.name,
    );
  });
}

export { collectDomainCompanies, sortCompaniesByPrimaryAndName };
